var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.shop, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "step" },
        [
          _c("span", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
          _c("span", {
            staticClass: "text",
            domProps: { innerHTML: _vm._s(item.text) },
          }),
          item.url
            ? _c("el-image", {
                staticStyle: { width: "400px" },
                attrs: { src: item.url, "preview-src-list": [item.url] },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }